<template>
  <div class="card">
    
    <div v-if="!hasVitals">
      <p>No vital signs yet, you can:</p>
      <ul>
        <li><router-link to="/add-item/vital">add entries manually</router-link></li>
        <li><router-link to="/cdas">upload CDA with vitals</router-link></li>
      </ul>
    </div>

    <div v-else>
      <div class="card-header">
        <togglable-caret-header 
        ref="vital-header"
        data-bs-toggle="collapse" 
        :data-bs-target="'#'+toggleTarget" 
        :showCaret="hasVitals"
        >
        <a>Vital Signs</a>
        </togglable-caret-header>
      </div>

      <div :id="toggleTarget" class="collapse show" >
        <div class="card-body">
          <measure-grid :selected="this.selected" :range="range" :grid="measAndDateGrid" :dates="datesForGrid" :isVitalSign="true" :isGrouping="this.grouping!='all'"></measure-grid>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { EventBus } from "../../../../event-bus";
  import {
    getDescByCcd,
    getMeasAndDateGridLimited,
    getCondensedDatesForGridLimited
  } from '@/data/getters'
  import {
    requestExternalMeasures
  } from '@/api/dataApi';
  import {getMeasureWeightByCcd} from "../../../../data/getters";
  import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
  import MeasureGrid from './MeasuresGrid';
  export default {
    name: 'vital-signs',
    components: {
      'togglable-caret-header': TogglableCaretHeader,
      'measure-grid': MeasureGrid
    },
    props: {
      grouping: {
        type: String,
        required: true
      },
      selected: {
        default: null
      },
      range: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        toggleHeading: 'vital-signs-heading',
        toggleTarget: 'vital-signs',
        checked: '',
        vitalGroupCodes: {'glucose': ['34204'], 'pulse': ['76633', '77371', '77808'], 'weight': ['21334', '23553', '77222', '32077'], 'breathing': ['54069', '54350', '77808' /*,'78221'*/], 'temperature': ['77229']}
      }
    },
    // created() {
    //   let loader = this.$loading.show({},{
    //     after: this.$createElement('div',{},['Loading vitals..'])
    //   });
    //   setTimeout(() => {
    //     loader.hide()
    //     loader = null
    //   }, 3000)
    // },
    mounted() {
      if (this.$route.query.open === 'vitals') {
        this.$refs['vital-header'].$el.click();
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      ...mapGetters('login/watch', {
        measuresWatching: 'getMeasuresWatching',
        proceduresWatching: 'getProceduresWatching',
        checkedMeasures: 'getCheckedMeasures',
        vitalCcds: 'getVitalSignCodes'
      }),
      vitalSigns() {
        let vitals = [];
        const meas = this.allData.measures;
        for (let measId in meas) {
          if (this.vitalCcds && this.vitalCcds.includes(meas[measId].codes[0])) {
              vitals.push(meas[measId]);
          }
        }
        return vitals;
      },
      vitalSignCcds() {
        let result = this.vitalSigns.map((vital)=>{return vital.codes[0];})
        if (this.grouping !== 'all') {
          result = result.filter(code => this.vitalGroupCodes[this.grouping].includes(''+code))
        }
        result = [...new Set(result)]
        return result
      },
      hasVitals() {
        return this.allData && this.vitalSigns.length > 0;
      },
      measAndDateGrid() {
        let today = Date.now();
        let limit = today - 1000 * 60 * 60 * 24 * this.range;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
        limit = new Date(limit);        
        let allGrid = getMeasAndDateGridLimited(this.allData, this.vitalSignCcds,limit)
        // if (this.grouping) {
        //   let groupGrid = []
        //   allGrid.forEach(measObj => {
        //     if (this.vitalGroupCodes[this.grouping].includes(measObj.ccd))
        //       groupGrid.push(measObj)
        //   })
        //   console.log(groupGrid)
        //   return groupGrid
        // }
        // console.log(allGrid)
        return allGrid
      },
      datesForGrid() {
        let today = Date.now();
        let limit = today - 1000 * 60 * 60 * 24 * this.range;   // current date's milliseconds - 1,000 ms * 60 s * 60 mins * 24 hrs * (# of days beyond one to go back)
        limit = new Date(limit);        
        let dates = getCondensedDatesForGridLimited(this.allData, this.vitalSignCcds,limit)
        return dates
      }
    },
    beforeDestroy() {
      delete this.vitalSigns;
      delete this.vitalSignCcds;
    },
    methods: {
      ...mapActions('login/watch', [
        'removeMeasure',
        'addCheckedMeasure',
        'removeCheckedMeasure'
      ]),
      ...mapActions('login', [
        'addMeasures'
      ]),
      /* sort measures based on weights */
      sortMeasCcds(measCcds) {
        // value=true, measCcd,
        let sortedMeasCcds = [];
        Object.keys(measCcds).forEach(measCcd => {
          sortedMeasCcds.push({
            id: measCcd,
            desc: this.getDescByCcd(measCcd, this.allData),
            weight: getMeasureWeightByCcd(measCcd, this.allData),
          })
        });

        return _.orderBy(sortedMeasCcds, 'weight', 'desc');
      },

      /* @param measures is a collection of objects grouped by ccd */
      getDescFromMeasures(measures) {
        return measures[Object.keys(measures)[0]].desc;
      },

      /**
       * Removes measure from watch list and graph
       */
      handleRemoveMeasure(procCcd, measCcd) {
        this.removeCheckedMeasure(measCcd);
        this.removeMeasure({proc: procCcd, meas: measCcd});
      },

      /**
       * Graphs measure
       * @param measCcd currently checked measurement id
       */
      handleCheckMeasure(measCcd) {
        // remove from list and graph if checked
        if (this.checkedMeasures[measCcd]) {
          this.removeCheckedMeasure(measCcd);
        } else {
          this.addCheckedMeasure(measCcd);
        }
      },
      getDescByCcd,
    }
  }
</script>

<style scoped lang="scss">
  .watch-list-section-title {
    padding-left: 1em;
    font-weight: bold;
  }
  .list-group {
    padding: 0;
  }
  .proc-group {
    padding-left: 0;
  }
  .list-group-item {
    padding: 0.5rem 0.5rem 0.5rem 2.0rem;
    border: none;

    &:nth-child(odd) {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
  .card-header {
    padding: 0.2rem;
    background-color: #fff;

    a {
      width: 100%;
      text-align: left;
    }
 }
  .card-body {
    padding: 0;
    font-size: 0.95rem;
  }

  .btn--remove {
    background-color: transparent;
    margin: 0;
    padding: 0;
    color: #ff4444;

    &:hover {
      color: #cc0000;
    }
  }
  .icon--remove {
    font-size: 1em;

  }
</style>
